import React, { useEffect } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { decodeStorage, encodeStorage } from 'functions/storageBase64'
import { BASE_PATH_PORTAL } from 'constants/general'
import { useSessionValidator } from 'hooks/useSessionValidator'

const getCookieValue = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
};

const syncCookiesToStorage = () => {
    const accessToken = getCookieValue('access_token');
    const refreshToken = getCookieValue('refresh_token');
    
    if (accessToken && !decodeStorage('access_token')) {
        encodeStorage('access_token', accessToken);
    }
    if (refreshToken && !decodeStorage('refresh_token')) {
        encodeStorage('refresh_token', refreshToken);
    }
    if (accessToken && !decodeStorage('session_token')) {
        encodeStorage('session_token', accessToken);
    }
}

const PrivateRoute = ({ component: Component, ...rest }) => {

    const basePath =  window.location.pathname
    const { isValidating, isValid, syncAndValidate } = useSessionValidator();

    useEffect(() => {
        const hasStorageToken = decodeStorage('session_token') || decodeStorage('access_token');
        const hasCookieToken = getCookieValue('access_token');
        
        if (!hasStorageToken && hasCookieToken) {
            syncAndValidate();
        }
    }, []);

    const hasSession = decodeStorage('session_token') || decodeStorage('access_token');

    if (isValidating) {
        return null;
    }

    if (!hasSession) {
        return basePath === '/Credito-Sears' || basePath === '/Credito-Sears/'
            ? <Redirect to={{ pathname: '/Credito-Sears/beneficios', state: { from: { pathname: basePath } } }} />
            : <script>{window.location.replace(`${BASE_PATH_PORTAL}/login?redirect=${window.location.href}`)}</script>;
    }

    return <Route {...rest} render={props => <Component {...props} />} />
}

export default PrivateRoute
